import { Link } from "react-router-dom";
import { ArrowUpRight, Heart, Trophy, ShoppingBag } from "@phosphor-icons/react";
import { shopHref } from "@/lib/kmsAccess";

/**
 * Hero for the Sacrifice / Legacy Challenge page. Self-contained — no props,
 * no state. Extracted from Sacrifice.jsx to keep the parent orchestrator lean.
 */
export default function SacrificeHero() {
  return (
    <section data-testid="sacrifice-hero" className="px-4 md:px-8 py-16 md:py-28 max-w-6xl mx-auto">
      <p className="text-[#B32027] uppercase tracking-[0.5em] text-xs sm:text-sm font-bold mb-6">/ Inaugural Year · September 2026</p>
      <p className="font-brush text-5xl md:text-7xl text-[#B32027] -rotate-2 inline-block mb-6">Who are you moving for?</p>
      <h1 className="font-display font-black uppercase leading-[1.05] tracking-tight text-5xl sm:text-7xl md:text-[120px]">
        <span className="block">Sweat&nbsp;for</span>
        <span className="font-brush font-normal normal-case text-[#B32027] -rotate-2 inline-block leading-[0.9] mt-2 md:mt-3">Sacrifice.</span>
      </h1>
      <div className="mt-8 md:mt-10">
        <p className="text-[10px] sm:text-xs uppercase tracking-[0.45em] font-bold text-white/50 mb-3">/ The Inaugural</p>
        <p className="font-display font-black uppercase tracking-tight leading-[1.05] text-3xl md:text-5xl text-white">
          9/11 Legacy<br className="sm:hidden" /> Challenge.
        </p>
      </div>
      <p className="mt-4 font-serif italic text-white/65 text-lg md:text-2xl">911 minutes of movement &middot; every minute carries a name.</p>

      <div className="mt-10 max-w-2xl space-y-5 text-white/80 text-lg leading-relaxed">
        <p>This September, I&rsquo;m inviting you to move for someone who matters.</p>
        <p>
          Sweat for Sacrifice is launching as an inaugural <span className="text-white font-semibold">911-minute movement challenge</span>, created in honor of my two uncles, <span className="text-white font-semibold">Tim Goss</span> and <span className="text-white font-semibold">Harry D&rsquo;Onofrio</span> &mdash; and for every person carrying a name, a story, or a legacy they never want forgotten.
        </p>
        <p>The goal is simple: complete <span className="text-white font-semibold">911 minutes of intentional movement</span> during the month of September.</p>
        <p>Walk, lift, run, bike, stretch, swim, golf, play pickleball, dance, take a class, or move however you can. Every minute counts.</p>
      </div>

      <div className="mt-12 flex flex-wrap gap-3">
        <button
          type="button"
          onClick={() => document.getElementById("legacy-signup")?.scrollIntoView({ behavior: "smooth", block: "start" })}
          data-testid="hero-cta-join"
          className="inline-flex items-center gap-3 bg-[#B32027] hover:bg-[#D42730] text-white px-8 py-4 text-[11px] font-bold uppercase tracking-[0.25em]"
        >
          Join the Legacy Challenge <ArrowUpRight size={14} weight="bold" />
        </button>
        <Link to="/legacy-wall" data-testid="hero-cta-legacy-wall" className="inline-flex items-center gap-3 border-2 border-white/30 hover:border-[#B32027] hover:text-[#B32027] text-white px-8 py-4 text-[11px] font-bold uppercase tracking-[0.25em] transition-colors">
          <Heart size={14} weight="fill" /> View the Legacy Wall
        </Link>
        <Link to="/sweat-for-sacrifice/leaderboard" data-testid="hero-cta-leaderboard" className="inline-flex items-center gap-3 border-2 border-white/30 hover:border-[#B32027] hover:text-[#B32027] text-white px-8 py-4 text-[11px] font-bold uppercase tracking-[0.25em] transition-colors">
          <Trophy size={14} weight="fill" /> View the Leaderboard
        </Link>
        <Link to={shopHref()} data-testid="hero-cta-shop-merch" className="inline-flex items-center gap-3 border-2 border-white/30 hover:border-[#B32027] hover:text-[#B32027] text-white px-8 py-4 text-[11px] font-bold uppercase tracking-[0.25em] transition-colors">
          <ShoppingBag size={14} weight="bold" /> Shop Legacy Merch
        </Link>
      </div>
    </section>
  );
}
